// FlixDetail.js
import { connect } from 'react-redux';
import { goBack } from 'redux-first-history';

import FlixDetail from '../page/FlixDetail.jsx';
import withRouter from '../component/WithRouter.jsx';

import {
  MESSAGE_BADGE_NONE,
  POST_DETAIL_THUMBNAIL_SIZE,
} from '../RemoteConfigKeys.js';
import { FLIX_DISPLAY_UNLOCK_COUNT } from '../RemoteConfigKeys.js';

import fetchDrmLicenseAvailability from '../action/fetchDrmLicenseAvailability.js';
import fetchMessageDetail from '../action/fetchMessageDetail.js';
import fetchMessageRating from '../action/fetchMessageRating.js';
import fetchUser from '../action/fetchUser.js';
import fetchFeeds from '../action/fetchFeeds.js';
import fetchMe from '../action/fetchMe.js';

import getMessageData from '../selector/getMessageData.js';
import getOperationData from '../selector/getOperationData.js';
import getUserData from '../selector/getUserData.js';
import getMeData from '../selector/getMeData.js';
import getNetworkingData from '../selector/getNetworkingData.js';
import getRouteHistory from '../selector/getRouteHistory.js';
import getMessageDuration from '../selector/getMessageDuration.js';
import { getKeySystem } from '../resource/getDrmInfo.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getMessageDataWithVariable, {
  VariableName,
} from '../selector/getMessageDataWithVariable.js';
import getNetworkingSummary from '../selector/getNetworkingSummary.js';

import fetchUserIsBlocked from '../action/fetchUserIsBlocked.js';
import fetchUserIsFollowing from '../action/fetchUserIsFollowing.js';
import clearTopVideoPopupNotifications from '../action/clearTopVideoPopupNotifications.js';
import toggleModal from '../action/toggleModal.js';
import i18n, { localeConvertor } from '../resource/i18n.js';

const mapStateToProps = (state, { messageId, location }) => {
  const meUsername = getMeData(state, 'username');
  const senderId = getMessageData(state, messageId, 'senderId');
  const canViewMedia = getMessageData(state, messageId, 'canViewMedia');

  const castIds = getMessageData(state, messageId, 'castIds');
  const firstCastUsername = castIds?.[0]
    ? getUserData(state, castIds[0], 'username')
    : '';

  const isFeedFirstPageFetched = !!getNetworkingData(
    state,
    ['home', 'messages', `message-${messageId}`, 1],
    'isFetched'
  );
  const fetchMessageDetailStatus = getNetworkingSummary(state, [
    'messages',
    messageId,
    'detail',
  ]);
  const sourceLanguage = localeConvertor({
    locale: getMessageData(state, messageId, 'source_language'),
  });
  const currentLanguage =
    getOperationData(state, ['config'], 'language') || i18n.language;
  const unlockPrice = getMessageData(state, messageId, 'unlockPrice');
  return {
    messageId,
    senderId,
    browserDrmRulesetTeststatus: getOperationData(state, ['drm'], 'testStatus'),
    senderName: getUserData(state, senderId, 'username'),
    firstCastUsername,
    canViewMedia,
    title: getMessageDataWithVariable(
      state,
      messageId,
      'title',
      `${VariableName.USERNAME}:${meUsername}`
    ),
    originalTitle: getMessageDataWithVariable(
      state,
      messageId,
      'originalTitle',
      `${VariableName.USERNAME}:${meUsername}`
    ),
    captionText: getMessageDataWithVariable(
      state,
      messageId,
      'description',
      `${VariableName.USERNAME}:${meUsername}`
    ),
    originalCaptionText: getMessageDataWithVariable(
      state,
      messageId,
      'originalCaptionText',
      `${VariableName.USERNAME}:${meUsername}`
    ),
    postedAtUnix: getMessageData(state, messageId, 'postedAtUnix'),
    scheduledAtUnix: getMessageData(state, messageId, 'scheduledAtUnix'),
    detailError: getNetworkingData(
      state,
      ['messages', messageId, 'detail'],
      'error'
    ),
    isFollowing: getUserData(state, senderId, 'isFollowing'),
    isAuthed: !!getMeData(state, 'id'),
    isPlayerFullscreen: getOperationData(state, ['player'], 'isFullscreen'),
    isPlayerMuted: getOperationData(state, ['player'], 'isMuted'),
    isPro: getMessageData(state, messageId, 'isPro'),
    isFree: unlockPrice === 0,
    previousRoute: getRouteHistory(state, 'previousRoute'),
    duration: getMessageDuration(state, messageId, location?.pathname),
    badges: getMessageData(state, messageId, 'badges'),
    messageBadgeNotShowList: getRemoteConfigData(state, MESSAGE_BADGE_NONE),
    thumbnailSize: getRemoteConfigData(state, POST_DETAIL_THUMBNAIL_SIZE),
    hasTranslation: getMessageData(state, messageId, 'hasTranslation'),
    isVideoControlDisplayed: getOperationData(
      state,
      ['player'],
      'isVideoControlDisplayed'
    ),
    shouldShowUnlockCount: getRemoteConfigData(
      state,
      FLIX_DISPLAY_UNLOCK_COUNT
    ),
    castIds,
    assetIds: getMessageData(state, messageId, 'assetIds'),
    isFeedFirstPageFetched,
    shouldFetchMessageTranslation: true, // For withFetchTranslation
    fetchMessageDetailError: fetchMessageDetailStatus?.error,
    isPublished: getMessageData(state, messageId, 'isPublished'),
    isLanguageMatched: sourceLanguage === currentLanguage,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchUserIsBlocked: ({ userId }) =>
      dispatch(fetchUserIsBlocked({ userId })),
    fetchUserIsFollowing: ({ userId }) =>
      dispatch(fetchUserIsFollowing({ userId })),
    goBack: () => dispatch(goBack()),
    fetchDetail: ({ id, httpProxyHeaders }) =>
      dispatch(fetchMessageDetail({ id, httpProxyHeaders })),
    fetchViewScope: ({ id }) =>
      dispatch(
        fetchDrmLicenseAvailability({
          keySystem: getKeySystem(),
          messageId: id,
        })
      ),
    fetchRating: id => dispatch(fetchMessageRating({ id })),
    fetchUser: ({ userId, httpProxyHeaders }) =>
      dispatch(fetchUser({ id: userId, httpProxyHeaders })),
    fetchFeeds: ({ type, page, httpProxyHeaders }) =>
      dispatch(fetchFeeds({ type, page, httpProxyHeaders })),
    fetchMe: () => dispatch(fetchMe()),
    clearTopVideoPopupNotifications: () =>
      dispatch(clearTopVideoPopupNotifications()),
    toggleModal: ({ modalId, payload, isOpen }) =>
      dispatch(toggleModal({ modalId, payload, isOpen })),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(FlixDetail)
);
